import { useEffect, useState } from "react";
import portalLogo from "../../assets/images/portal-logo.png";
import { getDomainFromUrl } from "../../utils/domainUtilities";

const NavTagline = () => {
    const [supportBox, setSupportBox] = useState(null);
    const DefaultBox = (
        <div className="NavTagline">
            <header>
                <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light border-bottom box-shadow custom-navbar">
                    <div className="container w-max2">
                        <a href="/"> <img src={portalLogo} className="w-sm" title="Portal" alt="Portal Logo" /> </a>
                        <span className="portal-label">Portal</span>
                        <div className="navbar-collapse d-sm-inline-flex flex-sm-row-reverse preReg-subtagline">
                            Simple, Secure, and Seamless Healthcare Communications
                        </div>
                    </div>
                </nav>
            </header>
        </div>
    );

    useEffect(() => {
        const initializeNavTagLine = async () => {
            try {
                const customNavTagLine = await import("../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/account/Support");

                setSupportBox(customNavTagLine.default());
            } catch {
                setSupportBox(DefaultBox);
            }
        };

        initializeNavTagLine();
    }, []);

    return <div>{supportBox}</div>;
};

export default NavTagline;
